import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_drawer = _resolveComponent("drawer");
  return _openBlock(), _createBlock(_component_drawer, {
    modelValue: $props.visible,
    ref: $setup.drawerRef,
    size: $props.size,
    title: $props.title,
    loading: $props.loading,
    className: $props.className,
    content: $props.content,
    "show-cancel-button": $props.showCancelButton,
    "cancel-button-text": $props.cancelButtonText,
    "show-confirm-button": $props.showConfirmButton,
    "confirm-button-text": $props.confirmButtonText,
    "show-header": $props.showHeader,
    "show-footer": $props.showFooter,
    "lock-view": $props.lockView,
    "lock-scroll": $props.lockScroll,
    mask: $props.mask,
    "mask-closable": $props.maskClosable,
    resize: $props.resize,
    "esc-closable": $props.escClosable,
    "confirm-closable": $props.confirmClosable,
    "cancel-closable": $props.cancelClosable,
    "show-close": $props.showClose,
    width: $props.width,
    height: $props.height,
    position: $props.position,
    "z-index": $props.zIndex,
    "show-title-overflow": $props.showTitleOverflow,
    transfer: $props.transfer,
    "destroy-on-close": $props.destroyOnClose,
    "before-hide-method": $props.beforeHideMethod,
    onShow: $setup.handleShow,
    onHide: $setup.handleHide,
    onConfirm: $setup.handleConfirm,
    onCancel: $setup.handleCancel,
    onClose: $setup.handleClose,
    onResize: $setup.handleResize
  }, _createSlots({
    _: 2
  }, [_renderList(Object.keys(_ctx.$slots), key => {
    return {
      name: key,
      fn: _withCtx(scope => [_renderSlot(_ctx.$slots, key, _normalizeProps(_guardReactiveProps(scope)))])
    };
  })]), 1032, ["modelValue", "size", "title", "loading", "className", "content", "show-cancel-button", "cancel-button-text", "show-confirm-button", "confirm-button-text", "show-header", "show-footer", "lock-view", "lock-scroll", "mask", "mask-closable", "resize", "esc-closable", "confirm-closable", "cancel-closable", "show-close", "width", "height", "position", "z-index", "show-title-overflow", "transfer", "destroy-on-close", "before-hide-method", "onShow", "onHide", "onConfirm", "onCancel", "onClose", "onResize"]);
}